import axios from 'axios';
import http from 'http';
import https from 'https';
import * as Sentry from '@sentry/react';
import { getToken } from './index';

const httpAgent = new http.Agent({ keepAlive: false });
const httpsAgent = new https.Agent({ keepAlive: false });

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  httpAgent,
  httpsAgent,
});

api.interceptors.request.use(async (config) => {
  const cfg = config;
  const token = await getToken();
  cfg.headers['Accept-Language'] = 'pt';
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }

  Sentry.addBreadcrumb({
    category: 'api-request',
    message: `Enviando requisição para: ${cfg.url}`,
    level: 'info',
    data: {
      url: cfg.url,
      method: cfg.method,
      headers: cfg.headers,
      payload: cfg.data,
    },
  });

  return cfg;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Fluxos com captura propria (saga) passam skipSentry para evitar evento
    // duplicado; os demais seguem sendo reportados aqui.
    if (!(error && error.config && error.config.skipSentry)) {
      Sentry.captureException(error, {
        extra: {
          url: error.config?.url,
          method: error.config?.method,
          headers: error.config?.headers,
          payload: error.config?.data,
        },
      });
    }

    return Promise.reject(error);
  }
);

export default api;
